import React, { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useTemplateDetailsStore } from '@store/templateDetailsStore';

import NewTemplate from '@pages/NewTemplate/NewTemplate';
import Loading from '@common/components/Loading/Loading';

export default function EditTemplate() {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get('id');

  const [isLoading, setIsLoading] = useState(false);

  const id = useTemplateDetailsStore((s) => s.id);
  const setTemplateDetailsInEdit = useTemplateDetailsStore(
    (s) => s.setTemplateDetailsInEdit,
  );
  const source = useTemplateDetailsStore((s) => s.source);

  useEffect(() => {
    const fetchTemplateDetails = async () => {
      setIsLoading(true);
      try {
        await setTemplateDetailsInEdit(templateId);
      } catch (err) {
        console.log('err: ', err);
      } finally {
        setIsLoading(false);
      }
    };

    templateId && fetchTemplateDetails();
  }, [templateId]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    id &&
    source?.structure && <NewTemplate isEditMode={true} editId={templateId} />
  );
}
